import GenericErrorScreen from '@/components/ErrorScreen';
import Footer from '@/components/Footers';
import LayoutComponent from '@/components/LayoutComponent';

import { layoutService } from '@/services/layout-service';
import { dataLayerPushWithEvent } from '@/utils/dataLayer';

import { Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSeoData, resetSeoData } from '@/store/seo/seoSlice';
import BuyRentSkeleton from '@/components/LayoutComponent/buyRentSkeleton';
import { useLocation } from '@/hooks/useLocation';
import { getCityFromUrl } from '@/utils/location';
const cities = ENV.CITIES;
const pipedCityNames = Object.keys(cities).join('|');

function Rent() {
	// const {isLoggedIn}=useSelector((state:any)=>{return state.user})
	const [layoutData, setLayoutData] = useState<any>();
	const [errored, setErrored] = useState(false);
	const { selectedLocation } = useLocation();
	const dispatch: any = useDispatch();
	useEffect(() => {
		setLayoutData(null);
		dataLayerPushWithEvent('moe_event', {
			moe_event_name: 'Home Page Loaded',
		});
	}, []);

	useEffect(() => {
		if (selectedLocation) {
			layoutService
				.getRentLayout()
				.then((res: any) => {
					setLayoutData(res.data.data);
				})
				.catch(() => {
					setErrored(true);
				});
		}

		const pathCity = getCityFromUrl();
		const locationsInCtx = pathCity ? selectedLocation : null;
		const title = locationsInCtx
			? 'Furniture on Rent in [City] | Furlenco'.replaceAll(
					'[City]',
					locationsInCtx.cityName
			  )
			: 'Furniture on Rent | Furlenco';

		const description = locationsInCtx
			? 'Rent award winning furniture & appliances in [City] from Furlenco. Enjoy super-fast delivery & furnish your dream home instantly. Rent Now!'.replaceAll(
					'[City]',
					locationsInCtx.cityName
			  )
			: 'Rent award winning furniture & appliances from Furlenco. Enjoy super-fast delivery & furnish your dream home instantly. Rent Now!';
		const contextKey = locationsInCtx
			? `SEO_FOOTER_${locationsInCtx.cityName.toUpperCase()}_HOME`
			: `SEO_FOOTER_GENERIC_HOME`;

		layoutService
			.getSeoContent(contextKey)
			.then((resp) => {
				return resp.data.data;
			})
			.then((data) => {
				dispatch(
					setSeoData({
						title,
						description,
						footerData: data.htmlContent,
					})
				);
			});
		return () => {
			dispatch(resetSeoData());
		};
	}, [selectedLocation]);
	return (
		<>
			<Container maxWidth='xl' sx={{ margin: '0 auto', padding: '0 32px' }}>
				{!errored ? (
					layoutData ? (
						<LayoutComponent {...layoutData} />
					) : (
						<BuyRentSkeleton />
					)
				) : (
					<GenericErrorScreen />
				)}
			</Container>
			<Footer />
		</>
	);
}
export default Rent;
